import PropTypes from 'prop-types';

export default {
  signInUser: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  })
};
